import { GlNavItem, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
export default {
    name: 'HelpCenterUpgradeSubscription',
    components: {
        GlNavItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    i18n: {
        upgradeSubscription: __('Upgrade subscription')
    },
    inject: [
        'isIconOnly'
    ],
    props: {
        upgradeLink: {
            type: String,
            required: true
        }
    }
};
